<template>
  <div>
    <HeadlineContainer headline="Edit Retention Touchpoint" :breadcrumbs="breadcrumbs">
      <button type="button" class="btn btn-white pull-right" @click="destroy">
        <i class="fa fa-trash"></i> Delete
      </button>
    </HeadlineContainer>

    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Edit Retention Touchpoint
            </h3>

            <p>
              Enter the details of the retention touchpoint.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the retention touchpoint."
                    :error="getError('name')"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import EmailFormGroup from '@/vendor/forms/FormGroups/Horizontal/Email'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    HeadlineContainer,
    HelpText,
    LoadingContainer,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  props: ['id'],

  data() {
    return {
      data: {},

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/retention-touchpoints', text: 'Retention Touchpoints'},
        {text: 'Edit'}
      ]
    },
  },

  methods: {
    load() {
      http.get('/api/v2/retention-touchpoints/' + this.id).then(response => {
        this.data = response.data.data.attributes

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/retention-touchpoints/' + this.id, this.data)
          .then(() => {
            notify.success('The retention touchpoint was saved')

            this.$router.push('/retention-touchpoints')
          })
          .catch(this.catchValidationErrors)
    },

    destroy() {
      modal.confirm('Are you sure that you want to delete the retention touchpoint?', () => {
        http.delete('/api/v2/retention-touchpoints/' + this.id)
            .then(() => {
              notify.success('The retention touchpoint was deleted')

              this.$router.push('/retention-touchpoints')
            })
      })
    }
  }
}
</script>
